import Nav from "./components/layout/Nav";
import Footer from "./components/layout/Footer";
import LiveBanner from "./components/layout/LiveBanner";
import Home from "./components/layout/Home";
import Discover from "./components/Discover/Discover";
import Swipe from "./components/Swipe/Swipe";
import Taste from "./components/Taste/Taste";
import Join from "./components/Join/Join";
import Film from "./components/Film/Film";
import Account from "./components/Account/Account";
import History from "./components/History/History";
import Together from "./components/Together/Together";
import Friends from "./components/Friends/Friends";
import AccountDetails from "./components/Account/AccountDetails";
import { Privacy, Support, Terms } from "./components/Legal/LegalPages";

import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/swipe" element={<Swipe />} />
        <Route path="/taste" element={<Taste />} />
        <Route path="/join/:code" element={<Join />} />
        <Route path="/film/:film_id" element={<Film />} />
        <Route path="/account" element={<Account />} />
        <Route path="/account/details" element={<AccountDetails />} />
        <Route path="/history" element={<History />} />
        <Route path="/together" element={<Together />} />
        <Route path="/friends" element={<Friends />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/support" element={<Support />} />
      </Routes>
      <LiveBanner />
      <Footer />
    </>
  );
}

export default App;
